import { FC, ReactNode } from 'react';
import {
  cvaOwnBlock,
  cvaOwnBlockInner,
} from '~/shared/ui/OwnBlock/OwnBlockStyles';
import clsx from 'clsx';

interface Props {
  children: ReactNode;
  containerClass?: string;
  className?: string;
  shadow?: boolean;
  variant?: 'own' | 'secondary' | 'third' | 'big' | 'default';
}

export const OwnBlock: FC<Props> = ({
  children,
  className,
  containerClass,
  variant,
  shadow,
}) => {
  return (
    <div
      className={clsx(
        cvaOwnBlock({ shadow, default: variant == 'default' }),
        containerClass
      )}>
      <div
        className={clsx(
          cvaOwnBlockInner({ size: variant ? variant : 'own' }),
          className
        )}>
        {children}
      </div>
    </div>
  );
};
